module.exports = __webpack_public_path__ + "img/IcnLogout.01bbe0e6.png";